import camelCase from 'lodash/camelCase'
import kebabCase from 'lodash/kebabCase'
import snakeCase from 'lodash/snakeCase'

const recursivelyCamelCaseObjectKeys = (object) => {
  if (typeof object !== 'object' || object === null) {
    return object
  }
  if (Array.isArray(object)) {
    return object.map((o) => recursivelyCamelCaseObjectKeys(o))
  }
  return Object.keys(object).reduce((previous, current) => {
    // eslint-disable-next-line no-param-reassign
    previous[camelCase(current)] = recursivelyCamelCaseObjectKeys(object[current])
    return previous
  }, {})
}

export default {
  toCamel: (s) => camelCase(s),
  toKebab: (s) => kebabCase(s),
  toSnake: (s) => snakeCase(s),
  toPascal: (s) => (camelCase(s)).replace(/^\w/, c => c.toUpperCase()),
  recursivelyCamelCaseObjectKeys
}
